import { Component } from '@angular/core';
import { NewsService, InboxInput } from './../../services/news.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { ModalController } from 'ionic-angular'; 
import { Letter } from './../../models/letter.model';
import { InboxSearch } from './inboxsearch';

@Component({
  selector: 'page-inbox',
  templateUrl: 'inbox.html',
  providers: [NewsService]
})
export class InboxPage {

  constructor(
    private newsService: NewsService,
    private alert: AlertService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private modalCtrl: ModalController) { }

  box = new InboxInput();
  isHave: boolean = false;
  newss: Letter[] = [];
  excludeTracks = [];
  hasmore = false;

  ionViewDidLoad() {
    let load = this.loadding.showLoding();
    this.record(this.box).then(s => {
      this.loadding.closeLoading(load);
    });
  }


  //查询事件点击
  //chen 2017-01-12
  record(obj: InboxInput) {
    return this.newsService.getNews(obj).then(s => {
      if (s.List != null) {
        if (obj.pageIndex == 1) {
          this.newss = [];
          this.newss = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.newss = this.newss.concat(s.List);
          if (this.newss.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            obj.pageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.newss = [];
      }
      if (this.newss.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }

    });
  }

  //查询条件
  //chen 2017-01-12
  presentFilter() {
    let modal = this.modalCtrl.create(InboxSearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.box.startTime = this.excludeTracks["startDate"];
        this.box.endTime = this.excludeTracks["endDate"];
        this.box.sendUserName = this.excludeTracks["people"] ? this.excludeTracks["people"] : "";
        this.box.pageIndex = this.excludeTracks["pageIndex"];
        this.record(this.box);
      }
    });
  }


  //下拉重新加载
  doRefresh(refresher) {
    this.box.pageIndex = 1;
    this.record(this.box).then(s => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2017-01-03
  doInfinite(infiniteScroll) {
    this.box.pageIndex++;
    this.record(this.box).then(s => {
      infiniteScroll.complete();
    });

  }

  callback = () => {
    this.record(this.box);
  }





}





// WEBPACK FOOTER //
// ./src/pages/inbox/inbox.ts